import type { OpportunityBoardFilters } from "@forgepoint/shared";

/** The three person filters, each backed by a field on OpportunityBoardFilters. */
export const PERSON_FILTER_FIELDS = [
  { key: "salesRepUserIds", label: "Sales Rep" },
  { key: "estimatorUserIds", label: "Estimator" },
  { key: "taskAssigneeUserIds", label: "Assignee" },
] satisfies { key: keyof OpportunityBoardFilters; label: string }[];

/** A person-filter field key (one of the three person filters). */
export type PersonFilterKey = (typeof PERSON_FILTER_FIELDS)[number]["key"];
